import { useState } from 'react'
import { User } from '../types'

export function useAuth() {
  const [user, setUser] = useState<User | null>(() => {
    const u = localStorage.getItem('user')
    return u ? JSON.parse(u) : null
  })

  // Active company for SUPER_ADMIN (null = see all, string = filtered)
  const [activeCompanyId, setActiveCompanyId] = useState<string | null>(() =>
    localStorage.getItem('activeCompanyId') || null
  )

  const login = (token: string, userData: User) => {
    localStorage.setItem('token', token)
    localStorage.setItem('user', JSON.stringify(userData))
    setUser(userData)
    // Clear active company on new login
    localStorage.removeItem('activeCompanyId')
    setActiveCompanyId(null)
  }

  const logout = () => {
    localStorage.removeItem('token')
    localStorage.removeItem('user')
    localStorage.removeItem('activeCompanyId')
    setUser(null)
    setActiveCompanyId(null)
  }

  const switchCompany = (companyId: string | null) => {
    if (companyId) {
      localStorage.setItem('activeCompanyId', companyId)
    } else {
      localStorage.removeItem('activeCompanyId')
    }
    setActiveCompanyId(companyId)
    // Reload page so all queries refetch with new company context
    window.location.reload()
  }

  const isSuperAdmin = user?.role === 'SUPER_ADMIN'
  const isAdmin = user?.role === 'ADMIN' || user?.role === 'SUPER_ADMIN'

  return { user, login, logout, isAdmin, isSuperAdmin, activeCompanyId, switchCompany }
}
